import React, { useEffect } from "react";
import PropTypes from "prop-types";
import createJWT from "Components/ChatSnippets/Zendesk/Jwt/authorization";

const ZendeskJWTComponent = ({ authData }) => {
  const {
    partnerNameOriginal,
    partnerSurnameOriginal,
    displayName,
    email,
    userName,
    id,
  } = authData;

  const fullName =
    partnerNameOriginal && partnerSurnameOriginal
      ? `${partnerNameOriginal} ${partnerSurnameOriginal}`
      : displayName;
  const userEmail = email || userName;
  const expirationTime = Math.floor(Date.now() / 1000) + 60;

  const userInfo = {
    name: fullName,
    email: userEmail,
    external_id: `ze-id-${id}`,
    email_verified: true,
    exp: expirationTime,
    scope: "user",
  };

  useEffect(() => {
    const generateJWTAndLogin = async () => {
      try {
        const jwtToken = await createJWT(userInfo);
        localStorage.setItem("jwtToken", jwtToken);

        const interval = setInterval(() => {
          if (window.zE) {
            clearInterval(interval);
            window.zE("messenger", "loginUser", (callback) => {
              callback(jwtToken);
            });
          } else {
            console.log("Zendesk SDK not loaded");
          }
        }, 500);
      } catch (error) {
        console.error(error);
      }
    };

    if (authData) {
      generateJWTAndLogin();
    }
  }, [authData, fullName]);

  return null;
};

ZendeskJWTComponent.propTypes = {
  authData: PropTypes.shape({
    partnerNameOriginal: PropTypes.string.isRequired,
    partnerSurnameOriginal: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    userName: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
};

export default React.memo(ZendeskJWTComponent);
